<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6 long-grass-pricing">
        <LsSupportHeader label="Long Grass Pricing" />
        <p>{{ pricingConcepts.length }} factors determine pricing</p>
        <main>
          <ul>
            <li v-for="({ title, description, images }, i) in pricingConcepts" :key="i">
              <p>
                <strong>{{ title }}</strong>
              </p>
              <p>{{ description }}</p>
              <div class="images">
                <figure class="bad"><img :src="getImageUrl(images.bad)" /></figure>
                <figure class="good"><img :src="getImageUrl(images.good)" /></figure>
              </div>
            </li>
          </ul>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getLongGrassPricingConcepts } from 'ls-constants';
import { themedComponentMixin } from '@/mixins';
import { LsSupportHeader } from '@/views/Authorized/SupportView/components';

export default {
  name: 'LongGrassPricingView',
  components: { LsSupportHeader },
  mixins: [themedComponentMixin],
  computed: {
    ...mapState(['featureFlags']),
    pricingConcepts() {
      return getLongGrassPricingConcepts();
    },
  },
  methods: {
    getImageUrl(path) {
      return `https://assets.${this.brandDomain}.com/${path}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.long-grass-pricing {
  & > p {
    color: $theme-color-primary;
    font-weight: 700;
    margin: 3rem 0 2rem;
  }
  main {
    ul {
      li {
        & ~ li {
          margin-top: 3rem;
        }
        .images {
          display: flex;
          margin-top: 1rem;
          figure {
            & ~ figure {
              margin-left: 1rem;
            }
          }
        }
      }
    }
  }
}
</style>
